import React from 'react';
import { Box, Card, CardContent, Grid, Typography } from '@material-ui/core';
import { useTranslation } from "react-i18next";

import useStyles from "./RepLIProfileContraceptiveMethods.style";


const RepLIProfileContraceptiveMethods = props => {
    const { t } = useTranslation();
    const classes = useStyles();

    const { profile } = props;

    return (
        (profile.contraception && (profile.contraception.length > 0)) &&
        <Grid container spacing={2} className={classes.root} >
            <Grid item xs={12}>
                <Typography variant="h4" color="primary">
                    {t('common.substantive.contraception')}
                </Typography>
            </Grid>
            {
                profile.contraception.map((method, i) =>
                    <Grid key={i} item xl={2} md={3} sm={6} xs={12}>
                        <Card>
                            <CardContent>
                                <Typography variant="h5" component="h2">
                                    {t('common.substantive.method')} #{i + 1}
                                </Typography>
                                <Typography color="textSecondary">
                                    {method.yearFrom} to {method.yearTo}
                                </Typography>
                                <Box>{method.method}</Box>
                            </CardContent>
                        </Card>
                    </Grid>

                )
            }
        </Grid>
    );
};

export default RepLIProfileContraceptiveMethods;